import * as React from "react";
/** This file contains dummy content that will be updated */
const TermsAndConditionsContent: React.FC<{}> = () => {
  return (
    <div>
      <p>
        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
        ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis
        dis parturient montes, nascetur ridiculus mus. Donec quam felis,
        ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa
        quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
        arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.
        Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras
        dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend
        tellus.
      </p>
    </div>
  );
};

export default TermsAndConditionsContent;



// WEBPACK FOOTER //
// ./src/Components/TermsAndConditions/TermsAndConditionsContent.tsx